import React from "react";
import { toast } from "react-toastify";

export const alertToast = (message) => {
  return new Promise((resolve) => {
    const toastId = toast(
      ({ closeToast }) => (
        <div className="w-full">
          <div className="mb-4 max-h-60 overflow-y-auto pr-2">
            <p className="whitespace-pre-line text-sm font-medium text-gray-800">
              {message}
            </p>
          </div>

          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={() => {
                closeToast();
                resolve(true);
              }}
              className="rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-red-700"
            >
              OK
            </button>
          </div>
        </div>
      ),
      {
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        position: "top-center",
        toastId: "alert-toast",
      },
    );
  });
};
